// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"8f597754047da3b84317","655":"97215abbffdac3fa3d06"}[chunkId] + ".js";
};